import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-section">
      <div className="container text-center">
        <h2 className="footer-heading">
          Your Style, Your Story. Perfected by Zrova!
        </h2>

        <div className="footer-buttons d-flex flex-wrap justify-content-center flex-md-row flex-column gap-3">
          <button
            className="footer-btn-outline"
            onClick={() => navigate("/contact")}
          >
            Book Now
          </button>

          {/* Email Link - Opens Email App */}
          <a
            href="mailto:Bookings@zrova.com.au"
            className="footer-btn-solid d-flex align-items-center gap-2 justify-content-center text-decoration-none"
          >
            <img
              src="/assets/gmail.png"
              alt="email Zrova"
              style={{ width: "22px", height: "22px", objectFit: "contain" }}
            />
            Bookings@zrova.com.au
          </a>

          {/* Phone Link - Opens Dialer */}
          <a
            href="tel:+61449977179"
            className="footer-btn-outline d-flex align-items-center gap-2 justify-content-center text-decoration-none"
          >
            <img
              src="/assets/telephone.png"
              alt="Call Zrova"
              style={{ width: "22px", height: "22px", objectFit: "contain" }}
            />
            +61 449 977 179
          </a>
        </div>

        <hr className="footer-divider" />

        <nav className="footer-nav">
          <button className="footer-btn" onClick={() => navigate("/about")}>
            About
          </button>
          <button className="footer-btn" onClick={() => navigate("/services")}>
            Services
          </button>
          <button className="footer-btn" onClick={() => navigate("/gallery")}>
            Gallery
          </button>
          <button className="footer-btn" onClick={() => navigate("/faqs")}>
            FAQs
          </button>
          <button className="footer-btn" onClick={() => navigate("/products")}>
            Products
          </button>
          <button
            className="footer-btn"
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </button>
        </nav>

        <hr className="footer-divider" />

        <p className="footer-copy">
          {/* © 2025 ZROVA Makeup & Hair. All rights reserved. */}©{" "}
          {new Date().getFullYear()} ZROVA Makeup & Hair. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
